export const ASSET_PROJECT_CLASS_NAME = 'AssetProjectDomain';
export const ASSET_PROJECT_COLLECTION = 'asset-projects';

export const MILESTONE_CLASS_NAME = 'MilestoneDomain';
export const MILESTONE_COLLECTION = 'milestones';

export const PROJECT_CLASS_NAME = 'ProjectDomain';
export const PROJECT_COLLECTION = 'projects';



// WEBPACK FOOTER //
// ./src/js/projects/domain/config.js